import _ from "lodash"

export const getUniqueBy = (array, value) => {
	return _.uniqBy(array, value)
}
